<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="nameModulo.toUpperCase() + ': ' + ItemSelect.Name" bindClass="col-md-7 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .card-body.bg-light  
                .form-row                    
                    .col-md-3.col-sm-12
                        label Nombre Report   
                        input.form-control.form-control-sm(v-model="parameterInsert.NameReport" )
                    .col-md-3.col-sm-12
                        label Url
                        input.form-control.form-control-sm(v-model="parameterInsert.UrlReport" )  
                    .col-md-2.col-sm-12
                        label 
                        button.btn.bg-primary.text-light.btn-block(@click="Insert()") AGREGAR 
                            i.fa.fa-plus  
            .card-body.bg-light    
                .form-group
                        table.table.table-sm.table-borderedonlytable
                            thead.bg-table.text-white
                                th Editar
                                th Nombre Report 
                                th Url   
                                th Estado                       
                            tbody.bg-white(name="table-fade", is="transition-group") 
                                tr(v-if="tableInfo.length", v-for="(item,index) in tableInfo", :key="index")
                                    td
                                        button.btn.btn-sm.btn-info(v-if="item.Update==0", @click="item.Update = 1")     
                                            i.fa.fa-edit  
                                        button.btn.btn-sm.btn-warning(v-else, @click="item.Update = 0; Update(item)")     
                                            i.fa.fa-floppy-o
                                    td
                                        div(v-if="item.Update == 0") {{item.NameReport}} 
                                        input.form-control.form-control-sm(v-else,v-model="item.NameReport", :readonly="item.Update==0 ? true:false") 
                                    td
                                        div(v-if="item.Update == 0") {{item.UrlReport}} 
                                        input.form-control.form-control-sm(v-else,v-model="item.UrlReport", :readonly="item.Update==0 ? true:false")  
                                    td  
                                        div(v-if="item.Update == 0") {{item.Active==1 ? 'Activo':'Inactivo'}}
                                        select.form-control.form-control-sm(v-else, v-model="item.Active" , :disabled="item.Update==0 ? true:false")
                                            option(value=1) Activa
                                            option(value=0) Inactiva                        
                  
</template>
<script>
import modal from "../../../complementos/modal.vue" 
import model from "../../../models/reportUrl.js" 
import apiWeb from "../../../api/apiSLC.js"
export default {
    props:{  
        IsShowModal:Boolean ,
        ItemSelect:Object 
    },  
    data(){
        return{
            nameModulo:'Reportes Cargados',
            pathApi:'ReportUrl/ReportUrl', 
            parameterUpdate:Object.assign({}, model.parameterUpdate),
            parameterInsert:Object.assign({}, model.parameterInsert),
            parameterView:Object.assign({}, model.parameterView), 
            
            tableInfo:[]  
        }
    },
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){
                            this.List_Info()  
                            return this.IsShowModal 
                        },
                        set(val){
                            this.List_Info()  
                            this.$emit("update:IsShowModal",val)
                        }
        } 
    },
    mounted(){
    
    this.parameterView.IdUser=this.ItemSelect.IdUser
       this.List_Info()
    },
    methods:{
        List_Info(){
            console.log("paso")
           this.parameterView.IdUser=this.ItemSelect.IdUser
          //  this.parameterView.IdEnterprise=this.$info.idEnterprise
            apiWeb.post(this.pathApi + "_View",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfo=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        } ,
        Insert(){
            console.log(this.parameterInsert)
            if(this.validate(this.parameterInsert)){ 
                this.parameterInsert.IdUser=this.ItemSelect.IdUser
                this.parameterInsert.User=this.$info.email
                this.parameterInsert.IP=this.$info.ip
                apiWeb.post(this.pathApi +"_Insert",this.parameterInsert)
                        .then(result=>{ 
                                if(result.status==0){
                                    this.List_Info()
                                    this.parameterInsert=Object.assign({}, model.parameterInsert) 
                                    this.$msgbox.show("Ingresado","Notificacion")
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                    this.List_Info()
                                }

                        })
                        .catch(ex=>{
                                    this.$msgbox.show(ex.message,"Error nivel 2")
                                    this.List_Info()})
            }
            
        },
        Update(item){
            this.parameterUpdate.IdReportURL=item.IdReportURL 
            this.parameterUpdate.NameReport=item.NameReport
            this.parameterUpdate.UrlReport=item.UrlReport 
            if(this.validate(this.parameterUpdate)){ 
                this.parameterUpdate.User=this.$info.email
                this.parameterUpdate.IP=this.$info.ip
                apiWeb.post(this.pathApi + "_Update",this.parameterUpdate)
                        .then(result=>{ 
                                if(result.status==0){
                                    this.List_Info()
                                    this.IsShowModalUpdate=false
                                    this.$msgbox.show("Actualizado","Notificacion")
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                     this.List_Info()
                                }
                        })
                        .catch(ex=>{
                                    this.$msgbox.show(ex.message,"Error nivel 2")
                                    this.List_Info()})
            }
        },
        validate(parameter){ 
            console.log(parameter)
            if(parameter.NameReport=='' || parameter.NameReport==null ){
                this.$msgbox.show("Ingrese Nombre","Alerta")
                return false
            }
            else if(parameter.UrlReport=='' || parameter.UrlReport==null ){
                this.$msgbox.show("Ingrese Url","Alerta")
                return false
            }                   
            else{
                return true
            }
        }
    }

    
}
</script>